<template>
  <div class="sxChangeApply">
    <Header title="实习异动申请"></Header>
    <!-- <NOdata title="功能暂未开放~"></NOdata>    -->
    <div class="apply">
      <div class="list-head">
        <p>当前实习状态</p>
        <i>{{ dqsxzt.mc }}</i>
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          class="update"
        >
          <template #reference>
            <span>更改</span>
          </template>
        </van-popover>
      </div>
      <van-field
        v-model="shr.mc"
        label="审核人"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="show1 = true"
        readonly
      />
      <van-field
        v-model="ydyy"
        rows="2"
        autosize
        label="异动原因"
        type="textarea"
        maxlength="500"
        placeholder="请输入留言"
        show-word-limit
      />

      <van-field label="上传附件" input-align="right" readonly>
        <template #input>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :max-size="10 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
          /> </template
      ></van-field>
    </div>
    <div class="bottom-btn">
      <span>
        <button @click="save()">申请并送审</button>
      </span>
    </div>
    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      shr: {},
      show1: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      dqsxzt: {},
      ydqzt: {},
      ydyy: "",
      file: {},
      fileList: [],
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [],
      list: {}
    };
  },
  created() {
    this.getList();
    this.getShr();
  },
  methods: {
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "586",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    },
    async getList() {
      const res = await Api.getsxydsqxx({
        sj0609xsid: this.$route.query.sj0609xsid
      });
      this.dqsxzt = {
        dm: res.data.dqsxztdm,
        mc: res.data.dqsxzt
      };
      this.ydqzt = {
        dm: res.data.dqsxztdm,
        mc: res.data.dqsxzt
      };
      this.actions = res.data.sxztlist.map(item => {
        return {
          text: item.dmmc,
          value: item.dm
        };
      });
    },
    async save() {
      if (this.ydqzt.dm == this.dqsxzt.dm) {
        this.$toast.fail("请更改实习状态！");
        return;
      }
      const res = await Api.sxydsqsave({
        id: "",
        ydqzt: this.ydqzt.dm,
        ydhzt: this.dqsxzt.dm,
        sqyy: this.ydyy,
        sj0609xsid: this.$route.query.sj0609xsid,
        userids: this.shr.dm,
        file1: this.file
      });
      if (res.code == "1") {
        this.$toast.success("提交送审成功");
        setTimeout(() => {
          this.$router.replace({
            path: "/sxChange/index"
          });
        }, 1500);
      } else {
        return;
      }
    },
    onSelect(action) {
      this.dqsxzt = {
        dm: action.value,
        mc: action.text
      };
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.file = file.file;
    },
    onOversize(file) {
      this.$toast.fail("文件大小不能超过10M");
    }
  }
};
</script>
<style lang="less" scoped>
.sxChangeApply {
  .apply {
    padding: 0 20px;
    height: 80vh;

    .list-head {
      height: 80px;
      background-image: url("../../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding: 6% 7%;
      box-sizing: border-box;
      margin-bottom: 5%;
      position: relative;
      flex-direction: column;
      p {
        height: 12px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #fff;
        letter-spacing: 0;
        font-size: 12px;
        color: #fff;
        font-weight: lighter;
        margin-bottom: 2%;
      }
      i {
        font-style: normal;
        font-size: 14px;
        color: #fff;
        margin-right: 5%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 70%;
      }

      .update {
        position: absolute;
        top: 15%;
        right: 7%;
        color: #fff;
        border-radius: 40%;
        font-size: 14px;
        padding: 1% 3%;
        background-color: #8f87f9;
      }
    }
  }
}
.bottom-btn {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 0 5% 10px 5%;
  background: #fff;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
  // span {
  //   display: inline-flex;
  //   justify-content: space-between;
  //   width: 100%;
  //   button:first-child {
  //     width: 45%;
  //     height: 44px;
  //     background: #ecedfd;
  //     border-radius: 3px;
  //     color: #7469f8;
  //   }
  //   button:last-child {
  //     width: 45%;
  //     height: 44px;
  //     background: #7469f8;
  //     border-radius: 3px;
  //     color: #fff;
  //   }
  //   .single {
  //     width: 100% !important;
  //   }
  // }
}
/* 审核人 */
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person {
  padding: 15px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.apply-pop .person .per-btn {
  background-color: #ecedfd;
  color: #7469f8;
}
.person .cur {
  background-color: #7469f8;
  color: #ecedfd;
}
</style>
<style lang="less">
.sxChangeApply {
  .apply {
    .van-cell {
      border-bottom: 1px solid #f4f4f4;
    }
    .van-cell::after {
      display: none;
    }
    .van-field__label {
      width: 7.2em;
      span {
        width: 96px !important;
        display: inline-block;
      }
    }
    .van-cell.van-field .van-cell__title.van-field__label > span {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      font-weight: normal;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      text-align: right;
      font-weight: bolder;
    }
    .van-icon-arrow {
      color: #dfe0e6;
      font-weight: bolder;
      font-size: 14px;
    }
    .van-cell__title,
    .van-cell.van-field .van-cell__title.van-field__label > span {
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxChange/apply.vue